module.exports = __webpack_public_path__ + "img/dynamic-14.2ae9b2c5.png";